export default "__VITE_ASSET__904e2817__"